import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { getRouteSection } from "@shared/Utils/get-route-details.util";

import permisos from "../../assets/constantes/permisos.json";
import { UserHasPermissionGuard } from "../../shared/Guards/user-has-permission.guard";

import { AsociarUsuarioComponent } from "./app-movil/asociar-usuario/asociar-usuario.component";
import { ConsultarUsuarioComponent } from "./app-movil/consultar-usuario/consultar-usuario.component";
import { DashboardCanalesComponent } from "./Dashboard/dashboard.component";
import { EditUserComponent } from "./EditUser/edit-user.component";
import { NotificacionesComponent } from "./notificaciones/notificaciones.component";
import { PermisosComponent } from "./permisos/permisos.component";
import { UserCreationComponent } from "./UserCreation/user-creation.component";

const getPageDetails = getRouteSection("canales");

const routes: Routes = [
  {
    path: "",
    component: DashboardCanalesComponent,
    canActivate: [UserHasPermissionGuard],
    data: {
      title: "Consulta Usuarios",
      requiredPermission: permisos.Canales.ConsultaUsuarios,
    },
  },
  {
    path: "permisos",
    component: PermisosComponent,
    canActivate: [UserHasPermissionGuard],
    data: {
      title: "Permisos de Usuarios",
      requiredPermission: permisos.Canales.ClonarPermisosUsuarios,
    },
  },
  {
    path: "notificaciones",
    component: NotificacionesComponent,
    canActivate: [UserHasPermissionGuard],
    data: {
      title: "Notificaciones",
      requiredPermission: permisos.Canales.EnviarNotificaciones,
    },
  },
  {
    path: "app-movil/asociar-usuario",
    component: AsociarUsuarioComponent,
    canActivate: [UserHasPermissionGuard],
    data: {
      title: "Asociar Usuario",
      requiredPermission: permisos.Canales.AsociarUsuario,
    },
  },
  {
    path: "app-movil/consultar-usuario",
    component: ConsultarUsuarioComponent,
    canActivate: [UserHasPermissionGuard],
    data: {
      title: "Consultar Usuario",
      requiredPermission: permisos.Canales.AsociarUsuario,
    },
  },
  {
    path: "creacion-usuario",
    component: UserCreationComponent,
    ...getPageDetails("userCreation"),
  },
  {
    path: "editar-usuario/:id",
    component: EditUserComponent,
    ...getPageDetails("userCreation"),
  },
  {
    path: "traspaso",
    ...getPageDetails("transferSearch"),
    loadComponent: () => import("./TransferRequestSearch/transfer-request-search.component"),
  },
  {
    path: "perfiles",
    ...getPageDetails("userCreation"),
    loadChildren: () => import("../Perfiles/perfiles-routing.module").then((m) => m.PerfilesRoutingModule),
  },
  {
    path: "roles",
    ...getPageDetails("userCreation"),
    loadChildren: () => import("../Roles/roles.module").then((m) => m.RolesModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CanalesRoutingModule {}
